export class CostReviewSummarySa {
    zone: string = '';
    salesOffice: string = '';
    projectName: string = '';
    customerName: string = '';
    siteLocation: string = '';
    roundTripMileage: string = '';
    period1StartDate: string = '';
    period1EndDate: string = '';
    numberOfPeriods: number = 0;
    contractEndDate: string = '';
    billingPeriod: string = '';
    agreementType: number = 0;
    agreementSubType: number = 0;
    customerType: any[] = [];
    opportunityLinked: string = '';
    proposalLinked: string = '';
    estimateDepth: number = 0;
    disciplinesIncluded: number[] = [];
    servicingOffices: string = '';
    isDRCApproved: number = 0;
    verticalMarket: string = '';
    isCollaborative: string = '';
}